import React, { useState, useEffect, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import MasterBKG from '../Common/Images/MasterBKG.png';
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";
import CustomAlert from '../Common/CustomAlert';
import CustomConfirmation from '../Common/CustomConfirmation';

const gfn_Trim = (str: string | undefined | null): string => {
  return str?.trim() || '';
};

interface FormData {
  dicFileName: string;
  lessonCode: string;
  country: string;
  curriculum: string;
}

interface DropdownData {
  countries: string[];
  curricula: string[];
  dicFiles: string[];
}

interface AlertInfo {
  show: boolean;
  message: string;
}

interface ConfirmInfo {
  show: boolean;
  message: string;
}

const RemoveLessonsFromWLP: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    dicFileName: '',
    lessonCode: '',
    country: '',
    curriculum: '',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dropdowns, setDropdowns] = useState<DropdownData>({
    countries: [],
    curricula: [],
    dicFiles: [],
  });
  const [alertInfo, setAlertInfo] = useState<AlertInfo>({ show: false, message: '' });
  const [confirmInfo, setConfirmInfo] = useState<ConfirmInfo>({ show: false, message: '' });

  const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';
  const navigate = useNavigate();

  useEffect(() => {

    document.body.style.backgroundColor = 'azure';
    const fetchDropdownData = async () => {
      try {
        const response = await fetch(`${API_BASE}api/get_dropdown_data`);
        const data = await response.json();
        setDropdowns({
          countries: data.countries || [],
          curricula: data.curricula || [],
          dicFiles: data.dicFiles || [],
        });
      } catch (error) {
        console.error("Failed to fetch dropdown data:", error);
        setAlertInfo({ show: true, message: "Failed to load dropdown data." });
      }
    };
    fetchDropdownData();
  }, []);

  const handleChange = (e: ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleRemove = () => {
    const { dicFileName, country, lessonCode, curriculum } = formData;

    if (!dicFileName) {
      setAlertInfo({ show: true, message: "Please select a DicFile." });
      return;
    }
    if (!country) {
      setAlertInfo({ show: true, message: "Please select the country." });
      return;
    }

    let msg2 = "";
    if (curriculum) {
      msg2 = `<br/><br/>Do you also want to remove all lessons with Dicfile: ${dicFileName} of Curriculum: ${curriculum} from Maths Doctor Maths Wiz Links?`;
    }

    if (gfn_Trim(lessonCode) === "") {
      setConfirmInfo({
        show: true,
        message: `Do you really want to delete all lessons of <br/>DicFile: ${dicFileName} from WLPs Country: <br/>${country}? ${msg2}`,
      });
    } else {
      const msg = curriculum
        ? "<br/><br/>Do you also want to remove lesson from Maths Doctor Maths Wiz Links?"
        : "";
      setConfirmInfo({
        show: true,
        message: `Do you want to delete the Record? ${msg}`,
      });
    }
  };

  const processDeletion = async () => {
    setConfirmInfo({ show: false, message: '' });
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE}api/remove_lessons_from_wlp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        setAlertInfo({ show: true, message: data.message || "Deleted successfully" });
      } else {
        setAlertInfo({ show: true, message: data.message || "Something went wrong" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setAlertInfo({ show: true, message: "Server error. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    navigate("/SysAdmin");
  };

  return (
    <div>
      {/* Custom Alert */}
      {alertInfo.show && (
        <CustomAlert
          message={alertInfo.message}
          onClose={() => setAlertInfo({ show: false, message: '' })}
        />
      )}

      {/* Custom Confirmation */}
      {confirmInfo.show && (
        <CustomConfirmation
          message={confirmInfo.message}
          onConfirm={processDeletion}
          onClose={() => setConfirmInfo({ show: false, message: '' })}
        />
      )}

      <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "16px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "12pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ marginLeft: "10px" }}>Remove lessons from WLP</span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
        <div
          className="cssbkImg"
          style={{
            backgroundImage: `url(${MasterBKG})`,
            width: "600px",
            height: "500px",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            verticalAlign: "top"
          }}
        >
          <div style={{ padding: "15% 0 0 0" }}>&nbsp;</div>

          <div style={{ fontSize: "22px", padding: "8px", textAlign: "center" }}>
            Delete DicFile / Lessons From WLP
          </div>

          <div style={{ verticalAlign: "top" }}>
            <table
              border={1}
              cellPadding="8"
              cellSpacing="8"
              align="center"
              style={{ width: "450px" }}
            >
              <tbody>
                <tr>
                  <td style={{ width: "40%", textAlign: "right" }}>DicFileName:&nbsp;</td>
                  <td style={{ width: "80%", textAlign: "left" }}>
                    <select
                      id="dicFileName"
                      style={{ width: "188px" }}
                      value={formData.dicFileName}
                      onChange={handleChange}
                    >
                      <option value="">--Select--</option>
                      {dropdowns.dicFiles.map((file) => (
                        <option key={file} value={file}>{file}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "right" }}>LessonCode:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <input
                      id="lessonCode"
                      type="text"
                      style={{ width: "180px" }}
                      value={formData.lessonCode}
                      onChange={handleChange}
                    />
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "right" }}>Country:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <select
                      id="country"
                      style={{ width: "188px" }}
                      value={formData.country}
                      onChange={handleChange}
                    >
                      <option value="">--Select--</option>
                      {dropdowns.countries.map((country) => (
                        <option key={country} value={country}>{country}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td style={{ textAlign: "right" }}>Curriculum:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <select
                      id="curriculum"
                      style={{ width: "188px" }}
                      title="This will remove lesson for a particular dic of the curriculum."
                      value={formData.curriculum}
                      onChange={handleChange}
                    >
                      <option value="">--Select--</option>
                      {dropdowns.curricula.map((curriculum) => (
                        <option key={curriculum} value={curriculum}>{curriculum}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2} style={{ textAlign: "center" }}>
                    <button
                      onClick={handleRemove}
                      disabled={isLoading}
                      className="cssButtonWithBorder"
                    >
                      {isLoading ? "Processing..." : "Remove"}
                    </button>
                    &nbsp;
                    <button onClick={handleClose} className="cssButtonWithBorder">
                      Close
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveLessonsFromWLP;